module.exports = __webpack_public_path__ + "assets/img/h3_logo_shadow.34cca58a.png";